import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import { MainLayout } from "../app/compartido/layout/MainLayout";
import { DashboardLayout } from "../app/privado/compartido/DashboardLayout";
import { Vigilante } from "../app/seguridad/Vigilate";
import { GuardiaRol } from "../app/seguridad/GuardiaRol";
import RecuperarContrasenia from "../app/publico/componentes/RecuperarContrasenia";
import NuevaContrasenia from "../app/publico/componentes/NuevaContrasenia";
import Registro from "../app/publico/paginas/Registro";

const Login = lazy(() => import("../app/publico/paginas/IniciarSesion"));
const Welcome = lazy(() => import("../app/publico/paginas/Welcome"));
const Dashboard = lazy(() => import("../app/privado/TableroPrincipal"));
const CambiarPassword = lazy(() => import("../app/privado/CambiarPassword"));
const Error = lazy(() => import("../app/compartido/Error"));

// Admin — Workflows
const WorkflowLista = lazy(() => import("../app/privado/admin/workflows/WorkflowLista"));
const WorkflowCrear = lazy(() => import("../app/privado/admin/workflows/WorkflowCrear"));
const WorkflowEditar = lazy(() => import("../app/privado/admin/workflows/WorkflowEditar"));

// Admin — Usuarios
const UsuariosLista = lazy(() => import("../app/privado/admin/usuarios/UsuariosLista"));
const UsuariosCrear = lazy(() => import("../app/privado/admin/usuarios/UsuariosCrear"));

// Admin — Entidades
const EntidadesLista = lazy(() => import("../app/privado/admin/entidades/EntidadesLista"));
const EntidadesCrear = lazy(() => import("../app/privado/admin/entidades/EntidadesCrear"));
const EntidadesEditar = lazy(() => import("../app/privado/admin/entidades/EntidadesEditar"));

// Admin — Departamentos
const DepartamentosLista = lazy(() => import("../app/privado/admin/departamentos/DepartamentosLista"));
const DepartamentosCrear = lazy(() => import("../app/privado/admin/departamentos/DepartamentosCrear"));
const DepartamentosEditar = lazy(() => import("../app/privado/admin/departamentos/DepartamentosEditar"));

// Admin — Ciudades
const CiudadesLista = lazy(() => import("../app/privado/admin/ciudades/CiudadesLista"));
const CiudadesCrear = lazy(() => import("../app/privado/admin/ciudades/CiudadesCrear"));
const CiudadesEditar = lazy(() => import("../app/privado/admin/ciudades/CiudadesEditar"));

// Admin — Barrios
const BarriosLista = lazy(() => import("../app/privado/admin/barrios/BarriosLista"));
const BarriosCrear = lazy(() => import("../app/privado/admin/barrios/BarriosCrear"));
const BarriosEditar = lazy(() => import("../app/privado/admin/barrios/BarriosEditar"));

// Gestión de trámites — admin, supervisor, funcionario, visitante
const DashboardGestionTramites = lazy(() => import("../app/privado/funcionario/DashboardGestionTramites"));

// Ciudadano
const MisTramitesLista = lazy(() => import("../app/privado/ciudadano/MisTramitesLista"));
const IniciarTramiteLista = lazy(() => import("../app/privado/ciudadano/IniciarTramiteLista"));

export const RuteoPrincipal = () => {
  return (
    <Suspense fallback={<div>Cargando...</div>}>
      <Routes>

        {/* 🌐 PUBLICO */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Welcome />} />
          <Route path="/login" element={<Login />} />

          {/* REGISTRO */}
          <Route path="/registro" element={<Registro />} />

          {/* 🔐 RECUPERAR PASSWORD */}
          <Route path="/recuperar-password" element={<RecuperarContrasenia />} />

          {/* 🔐 RESET PASSWORD CON TOKEN */}
          <Route path="/restablecer-password/:token" element={<NuevaContrasenia />} />
        </Route>

        {/* 🔐 PRIVADO */}
        <Route
          element={
            <Vigilante>
              <DashboardLayout />
            </Vigilante>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/cambiar-password" element={<CambiarPassword />} />

          {/* Admin — solo rol "admin" */}
          <Route element={<GuardiaRol rolesPermitidos={["admin"]} />}>
            <Route path="/dashboard/admin/workflows" element={<WorkflowLista />} />
            <Route path="/dashboard/admin/workflows/crear" element={<WorkflowCrear />} />
            <Route path="/dashboard/admin/workflows/:id/editar" element={<WorkflowEditar />} />
            <Route path="/dashboard/admin/usuarios" element={<UsuariosLista />} />
            <Route path="/dashboard/admin/usuarios/crear" element={<UsuariosCrear />} />
            <Route path="/dashboard/admin/entidades" element={<EntidadesLista />} />
            <Route path="/dashboard/admin/entidades/crear" element={<EntidadesCrear />} />
            <Route path="/dashboard/admin/entidades/:id/editar" element={<EntidadesEditar />} />
            <Route path="/dashboard/admin/departamentos" element={<DepartamentosLista />} />
            <Route path="/dashboard/admin/departamentos/crear" element={<DepartamentosCrear />} />
            <Route path="/dashboard/admin/departamentos/:id/editar" element={<DepartamentosEditar />} />
            <Route path="/dashboard/admin/ciudades" element={<CiudadesLista />} />
            <Route path="/dashboard/admin/ciudades/crear" element={<CiudadesCrear />} />
            <Route path="/dashboard/admin/ciudades/:id/editar" element={<CiudadesEditar />} />
            <Route path="/dashboard/admin/barrios" element={<BarriosLista />} />
            <Route path="/dashboard/admin/barrios/crear" element={<BarriosCrear />} />
            <Route path="/dashboard/admin/barrios/:id/editar" element={<BarriosEditar />} />
            <Route path="/dashboard/admin/tramites" element={<DashboardGestionTramites />} />
          </Route>

          {/* Gestión de trámites — funcionario, supervisor, visitante */}
          <Route element={<GuardiaRol rolesPermitidos={["funcionario", "supervisor", "visitante"]} />}>
            <Route path="/dashboard/tramites" element={<DashboardGestionTramites />} />
          </Route>

          {/* Ciudadano — solo rol "ciudadano" */}
          <Route element={<GuardiaRol rolesPermitidos={["ciudadano"]} />}>
            <Route path="/dashboard/ciudadano/tramites" element={<MisTramitesLista />} />
            <Route path="/dashboard/ciudadano/iniciar" element={<IniciarTramiteLista />} />
          </Route>

          <Route path="/dashboard/*" element={<Error />} />
        </Route>

        {/* 🌍 GLOBAL 404 */}
        <Route path="*" element={<Error />} />

      </Routes>
    </Suspense>
  );
};